
import { Routes, Route, Link } from "react-router-dom";
import React, { useState, useEffect,useRef } from "react";
import ImageUploading from 'react-images-uploading';
import { useNavigate,useHistory } from "react-router-dom";
import axios from 'axios';
import { auth } from "../firebase/firebaseDb.js";
import { ToastContainer, toast } from 'react-toastify';
import Header from "../components/Header";
import Lottie from "lottie-react";
import SuccessLottie from "./success-lottie.json";
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3';
import { useTranslation } from "react-i18next";


import { 
FacebookAuthProvider,
 GoogleAuthProvider,
 signInWithPopup ,
 signInWithRedirect,
 OAuthProvider,
 sendSignInLinkToEmail,
 createUserWithEmailAndPassword,
 signInWithEmailAndPassword,
 updateProfile,
 sendEmailVerification,
 onAuthStateChanged
 } from "firebase/auth";









export default function Credit() {
	
	 const modalRef = useRef();
	// const [progress, setProgress] = useState(10); // initial 10%
	   const { t } = useTranslation();
	   const [selectedServiceName, setSelectedServiceName] = useState('');
       const [selectedServiceDescription, setSelectedServiceDescription] = useState('');
	   const [serviceMode, setServiceMode] = useState('save');
	   const [oldServiceName, setOldServiceName] = useState('');
	   
	   const [businessName, setBusinessName] = useState('');
	   const [businessType, setBusinessType] = useState('');
	   const [businessAddress, setBusinessAddress] = useState('');
	   const [businessEmail, setBusinessEmail] = useState('');
	   const [businessPhone, setBusinessPhone] = useState('');
	    const [services, setServices] = useState([]);
	   const [images, setImages] = React.useState([]);
  	   
		
	   const [step, setStep] = useState(0);
	   const [inputReply, setInputReply] = useState('');
	    const [showInputReply, setShowInputReply] = useState('flex');
	 const [showSpinner, setShowSpinner] = useState('none');	
	   const [stepInput,setStepInput]=useState('');
	   const maxNumber = 15;
	   const [websiteGeneratorStatus, setWebsiteGeneratorStatus] = useState('');
	  const [remoteImages, setRemoteImages] = useState([]); 
   const [createdWebsiteID, setCreatedWebsiteID] = useState('');	  
	   const [openAIResult, setOpenAIResult]=useState(null);
	   const [urlPath, setUrlPath]=useState('');
	  const [userInfo, setUserInfo]=useState(JSON.parse(localStorage.getItem('user_info'))); 
	  const [firebaseUserInfo, setFirebaseUserInfo]=useState(JSON.parse(localStorage.getItem('firebase_user')));
 //  const [firebaseUserInfo, setFirebaseUserInfo]=useState(JSON.parse(localStorage.getItem('firebase_user'))); 
    const [websitesList, setWebsitesList]=useState([]);   
	const [giftCode, setGiftCode]=useState([]);  
    const [websiteLoadState, setWebsiteLoadState]=useState('loading');
	const [paymentData, setPaymentData] = useState({
    currency: 'USD', // Default
    price: 35,       // Your base price for credits
    loading: true
  });
  
  
  const BASE_PRICE_CAD = 50;
	  
	 const questions = [
    "Let’s get started! What’s the name of your business?",
    "Which type of activity are your business serve?",
    "Where is your business located?",
	"What's your email",
	"What is your phone number",
    "What’s your business products or services?",
	"Choose few images in your library that will be use for your website"
  ];

  const placeholders = [
     "eg ZuriBuild Inc.",
	"eg barbershop",
    "eg Lagos, Nigeria",
    "eg example@email.com",
	"Your phone number",
	"Services / products",
	"Images gallery"
  ];
  
  
  
  const WP_API = "http://localhost/zuribuild/wp-json/wp/v2/pages";
const USERNAME = "kevin_joel"; // your WP username
const APP_PASSWORD = "KB2t qtrb bVqD zzJD iP9A 6irA"; // your generated Application Password
const token = btoa(`${USERNAME}:${APP_PASSWORD}`);

const navigate = useNavigate();



// Flutterwave Configuration
  const config = {
    public_key: process.env.REACT_APP_FLUTTERWAVE_API_KEY,
    tx_ref: `tx-${Date.now()}`,
    amount: paymentData.price,
    currency: paymentData.currency,
	//country:'CD',
    payment_options: '*',
    customer: { email: firebaseUserInfo.email, name: firebaseUserInfo.displayName },
	  meta: {
    email: firebaseUserInfo.email,
	type: 'top-up-credit',
	phone: '0000'
    
  },
    customizations: {
      title: 'Credit Top-up',
      description: `Payment for Credits in ${paymentData.currency}`,
    },
  };

  const handleFlutterPayment = useFlutterwave(config);







	 useEffect(() => {
		 
		 	   if (!localStorage.getItem('user_info')) {
      navigate('/login');
      return;
    }
	console.log(firebaseUserInfo.email)	 
// console.log(userInfo)	


fetch('https://api.ipdata.co?api-key=9b5aa5d92f15533eb5d87fb94e17706c0fd437424167ce9df355528a') // "test" key has limitations
  .then(response => response.json())
  .then(data => {
      
    const countryCode = data.country_code;
    const currencyCode = data.currency.code;
    console.log("Country Code:", countryCode);
    console.log("Currency Code:", currencyCode);
	
//	 alert(countryCode);
	// document.getElementById('price-class').innerText='20.000FCFA';
	// document.getElementById('payment-method-class').innerText='MTN MOBILE MONEY,MOMO';
	
	if(countryCode=='CM'){
		  setPaymentData({
          currency: currencyCode,
          price: 20000,
          loading: false
        });
	//alert('canada');
	// document.getElementById('price-class').innerText='20.000FCFA';
	// document.getElementById('payment-method-class').innerText='MTN MOBILE MONEY,MOMO';
	}
	
	else if(countryCode=='BF'){
		
		setPaymentData({
          currency: currencyCode,
          price: 50000,
          loading: false
        });
	// document.getElementById('price-class').innerText='20.000FCFA';
	// document.getElementById('payment-method-class').innerText='ORANGE MONEY,MOBICASH';
	}
	
	
	else if(countryCode=='BJ'){
		setPaymentData({
          currency: currencyCode,
          price: 20000,
          loading: false
        });
	// document.getElementById('price-class').innerText='20.000FCFA';
	// document.getElementById('payment-method-class').innerText='MOMO, AIRTEL MONEY';
	}
	
	
	else if(countryCode=='CD'){
		setPaymentData({
          currency: 'USD',
          price: 35,
          loading: false
        });
	// document.getElementById('price-class').innerText='35$';
	// document.getElementById('payment-method-class').innerText='VISA,MASTERCARD,AIRTEL MONEY';
	}
	
		else if(countryCode=='CI'){
			setPaymentData({
          currency: currencyCode,
          price: 20000,
          loading: false
        });
	// document.getElementById('price-class').innerText='20.000FCFA';
	// document.getElementById('payment-method-class').innerText='MTN, ORANGE MONEY, MOOV, WAVE';
	}
	
	
	
		else if(countryCode=='DZ'){
			setPaymentData({
          currency: currencyCode,
          price: 4600,
          loading: false
        });
	// document.getElementById('price-class').innerText='4600DZD';
	// document.getElementById('payment-method-class').innerText='VISA,MASTERCARD,Barid Pay, Wimpay';
	}
	
	
			else if(countryCode=='EG'){
			setPaymentData({
          currency: currencyCode,
          price: 1700,
          loading: false
        });	
	// document.getElementById('price-class').innerText='1700EGP';
	// document.getElementById('payment-method-class').innerText='BANK TRANSFER,CASH PAYMENT(Fawry Pay) , VISA, MASTERCARD';
	}
	
	
		else if(countryCode=='GA'){
			setPaymentData({
          currency: currencyCode,
          price: 20000,
          loading: false
        });
	// document.getElementById('price-class').innerText='20.000FCFA';
	// document.getElementById('payment-method-class').innerText='AIRTEL MONEY,VISA,MASTERCARD';
	}
	
	
	
		else if(countryCode=='GH'){
			setPaymentData({
          currency: currencyCode,
          price: 410,
          loading: false
        });
	// document.getElementById('price-class').innerText='410CEDI';
	// document.getElementById('payment-method-class').innerText='MTN,AIRTEL,TIGO,VISA,MASTERCARD';
	}
	
	
		else if(countryCode=='GN'){
			setPaymentData({
          currency: currencyCode,
          price: 200000,
          loading: false
        });
	// document.getElementById('price-class').innerText='200.000GNF';
	// document.getElementById('payment-method-class').innerText='ORANGE MONEY,MTN MOBILE MONEY,VISA,MASTERCARD';
	}
	
	
		else if(countryCode=='KE'){
			setPaymentData({
          currency: currencyCode,
          price: 4600,
          loading: false
        });
	// document.getElementById('price-class').innerText='4600KES';
	// document.getElementById('payment-method-class').innerText='MPESA';
	}
	
	
	
		else if(countryCode=='MA'){
			setPaymentData({
          currency: currencyCode,
          price: 328,
          loading: false
        });
	// document.getElementById('price-class').innerText='328MAD';
	// document.getElementById('payment-method-class').innerText='PAYPAL,VISA,MASTERCARD';
	}
	
	
		else if(countryCode=='MW'){
			setPaymentData({
          currency: currencyCode,
          price: 62000,
          loading: false
        });
	// document.getElementById('price-class').innerText='62000MWK';
	// document.getElementById('payment-method-class').innerText='MOBILE MONEY,VISA,MASTERCARD';
	}
	
	
	
		else if(countryCode=='NG'){
			setPaymentData({
          currency: currencyCode,
          price: 51000,
          loading: false
        });
	// document.getElementById('price-class').innerText='51000NGN';
	// document.getElementById('payment-method-class').innerText='BANK TRANSFER,OPAY,ENAIRA,USSD,VISA,MASTERCARD';
	}
	
	
		else if(countryCode=='RW'){
			setPaymentData({
          currency: currencyCode,
          price: 51000,
          loading: false
        });
	// document.getElementById('price-class').innerText='51000RWF';
	// document.getElementById('payment-method-class').innerText='MOBILE MONEY,VISA,MASTERCARD';
	}
	
	
	
		else if(countryCode=='SN'){
			setPaymentData({
          currency: currencyCode,
          price: 20000,
          loading: false
        });
	// document.getElementById('price-class').innerText='20.000FCFA';
	// document.getElementById('payment-method-class').innerText='ORANGE,FREE MONEY,WAVE,VISA,MASTERCARD';
	}
	
	
	
		else if(countryCode=='TG'){
	 document.getElementById('price-class').innerText='20.000FCFA';
	 document.getElementById('payment-method-class').innerText='TMONEY(TOGOCOM), FLOOZ(MOOV), VISA,MASTERCARD';
	}
	
	
	
		else if(countryCode=='TN'){
			setPaymentData({
          currency: currencyCode,
          price: 105,
          loading: false
        });
	// document.getElementById('price-class').innerText='105TND';
	// document.getElementById('payment-method-class').innerText='QNBpay, eDinar,VISA,MASTERCARD';
	}
	
	
	
		else if(countryCode=='TZ'){
			setPaymentData({
          currency: currencyCode,
          price: 89000,
          loading: false
        });
	// document.getElementById('price-class').innerText='89000TZS';
	// document.getElementById('payment-method-class').innerText='MOBILE MONEY,VISA,MASTERCARD';
	}
	
	
	
			else if(countryCode=='UG'){
				setPaymentData({
          currency: currencyCode,
          price: 130000,
          loading: false
        });
	// document.getElementById('price-class').innerText='130000UGX';
	// document.getElementById('payment-method-class').innerText='MOBILE MONEY,VISA,MASTERCARD';
	}
	
	
	
			else if(countryCode=='ZA'){
				setPaymentData({
          currency: currencyCode,
          price: 604,
          loading: false
        });
	// document.getElementById('price-class').innerText='604RAND';
	// document.getElementById('payment-method-class').innerText='GOOGLE PAY,APPLE PAY,VISA,MASTERCARD';
	}
	
	
	
			else if(countryCode=='ZM'){
				setPaymentData({
          currency: currencyCode,
          price: 818,
          loading: false
        });
	// document.getElementById('price-class').innerText='818ZMW';
	// document.getElementById('payment-method-class').innerText='MOBILE MONEY,VISA,MASTERCARD';
	}
	
	
		
			else if(countryCode=='CA'){
		setPaymentData({
          currency: currencyCode,
          price: 50,
          loading: false
        });	   
	// document.getElementById('price-class').innerText='50CAD';
	// document.getElementById('payment-method-class').innerText='DEBIT VISA,MASTERCARD';
	}
   
  })
  .catch(error => {
    console.error("Error fetching location data:", error);
});









	 
		 
		
 

  
  }, []);
































const changeTheme= async () =>{
	
	
    try {
        const response = await axios.post(
            "http://localhost/zuribuild/wp-json/custom/v1/switch-theme",
			{
			site_id:24,	
			theme: "kadence"	
			//theme: "twentytwentyfour"	
			},
            {
                headers: {
                     Authorization: `Basic ${token}`,
				//	 Authorization: `Basic ${Buffer.from(`kevin:${APP_PASSWORD}`).toString('base64')}`, // Assuming 'admin' is your username
                    'Content-Type': 'application/json',
                },
            }
        );
  
        console.log('Theme changed successfully:', response);
		//alert(response.data)
    } catch (error) {
		//alert(error.message)
        console.error('Error changing theme:', error.response ? error.response.data : error.message);
    }
	
}


const goToMain = () => {
	setStep(0)
}



 

const goToPayment = () => {
	setStep(2)
}




const goToGiftCode = () => {
	setStep(1)
}



  
  
   const handleNext = () => {
	   //alert(step)
  /*  if (step < questions.length - 1) {
      setStep(step + 1);
    } */
	
	   if (step < questions.length - 1) {
	if(step==0){
	  setStep(step + 1);
	}
	
	
 if(step==1){
	 if(businessType==''){
		//alert("this have to be filled")
setShowInputReply('flex ')		
		setInputReply('This field is required ')
		}
		else{
		
  setStep(step + 1);
		}
 }	


 if(step==2){

		
  setStep(step + 1);
		
 }


 if(step==3){
	 if(businessEmail==''){
		//alert("this have to be filled")
setShowInputReply('flex ')		
		setInputReply('This field is required ')
		}
		else{
			setShowInputReply('none')		
		setInputReply('')
  setStep(step + 1);
		}
 } 
 
 
 
  if(step==4){
	 if(businessPhone==''){
		//alert("this have to be filled")
setShowInputReply('flex ')		
		setInputReply('This field is required ')
		}
		else{
			setShowInputReply('none')		
		setInputReply('')
  setStep(step + 1);
		}
 }
 
 
   if(step==5){
	
  setStep(step + 1);
		
 }
	   }
	

  };
  
  
  
  
  
  
  
 //function to verify the gift code to the database----------------------------------------------------------------------------------- 
  
  
  const verifyGiftCode=async()=>{
	  if(giftCode==''){
		  alert("You need to enter a valid gift code")
	  }
	  
	  else{
	  
	   setShowSpinner('inline-block')
	  const payload={
		  beneficiary_email:firebaseUserInfo.email,
		 credit_code: giftCode
	  }
	  
	  
	 // axios.post("http://localhost/zuribuildAPI/gift-code.php", payload, {
		axios.post(process.env.REACT_APP_PHP_API_URL+"zuribuildAPI/gift-code.php", payload, { 
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
	// alert(res.data)
	 if(res.data=='invalid'){
		// alert("The gift code you entered is invalid or expired!!!")
		 	   toast.error("The gift code you entered is invalid or expired!!!", {
      position: 'top-right',
    });
	 }
	 
	 else{
		 navigate("/success-credit")
		// navigate.push('/success-credit');
	 }
	
	 
    })
    .catch((err) => {
		 setShowSpinner('none')
      console.error("Error:", err);
	alert(err)
    });
	  }
  }
  
  
  
  
  
  //function to check the business name in my database
  const checkBusinessName=async()=>{
	  setShowSpinner('inline-block')
	  const payload={
		 website_name:businessName, 
	  }
	  axios.post("http://localhost/zuribuildAPI/search-website.php", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
	  if(res.data=='Business no found'){
		  setStep(step + 1);  
 setShowInputReply('none')
	setInputReply('')
	  }
	  
	  else{
		//alert("This business  already taken. You have to choose another business name") 
setShowInputReply('flex')
	setInputReply('This business name already taken. You have to choose another name')		
	  }
	//  alert(res) 
	
	 
    })
    .catch((err) => {
		 setShowSpinner('none')
      console.error("Error:", err);
	alert(err)
    });
	  
  }
  
  
  
  
  
  
   const onChangeImage = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };
  
  
  
  
  
  
  //function to check if the business name already exist in the database
  const checkBusinessNameAvailability=()=>{
	 // alert("we wil check if this business name already exist")
	  
  }
  
  
  
    const handleBack = () => {
		setShowInputReply('none ')		
		setInputReply('')
    if (step > 0) {
      setStep(step - 1);
    }
  };
  
  
  
    const addNewService = () => {

//  var newService=[{name:selectedServiceName, description:selectedServiceDescription}]
//  setServices([...services,{name:selectedServiceName, description:selectedServiceDescription}])
  
//  setSelectedServiceName('');
//  setSelectedServiceDescription('');
  
 /*if(services.lenght>0){
  console.log(services[0].name);
 } */
 const modal = window.bootstrap.Modal.getInstance(modalRef.current);

  if(serviceMode=='save'){
	  var newService=[{name:selectedServiceName, description:selectedServiceDescription}]
  setServices([...services,{name:selectedServiceName, description:selectedServiceDescription}])
	   modal.hide();
	   setSelectedServiceName('');
       setSelectedServiceDescription('');
	   setServiceMode('save');
  }
  
  else if(serviceMode=='edit'){
	//  alert(selectedServiceName)
 setServices((prevServices) =>
      prevServices.map((service) =>
        service.name === oldServiceName
          ? { name: selectedServiceName, description: selectedServiceDescription }
          : service
      )
    );
	  setServiceMode('save');
	   modal.hide();
	   setSelectedServiceName('');
       setSelectedServiceDescription('');
  }
   
   
  };
  
  
  
  
  
  
  
  

  // progress = (currentStep + 1) / totalSteps * 100
  const progress = ((step + 1) / questions.length) * 100;



 // Service functions
  const handleServiceChange = (index, field, value) => {
    const newServices = [...services];
    newServices[index][field] = value;
    setServices(newServices);
  };

  const addService = () => {
    setServices([...services, { name: "", description: "" }]);
  };
	
	
	

	
	
	
	
	
	// Function to remove an item by id
  const removeService = (name) => {
	  
	//  alert(id)
    setServices((prevServices) =>
      prevServices.filter((service) => service.name !== name)
    );
  };
	
	
	//function to view the service detail
	const viewService = (name,description) => {

 
  setServiceMode('edit');
  setOldServiceName(name);
  setSelectedServiceName(name);
  setSelectedServiceDescription(description);
  
 /*if(services.lenght>0){
  console.log(services[0].name);
 } */

  
   const modal = window.bootstrap.Modal.getInstance(modalRef.current);
    modal.show();
  };
	
	
	
	
	
	//function to close the service modal
	const closeModal = () => {

 
  
  setSelectedServiceName('');
  setSelectedServiceDescription('');
  

  
   const modal = window.bootstrap.Modal.getInstance(modalRef.current);
    modal.hide();
  };
	
	
	
//function to replace a service 

const replaceService = (oldName, newService) => {
  setServices((prevServices) =>
    prevServices.map((service) =>
      service.name === oldName ? newService : service
    )
  );
};	
	
	
	
	
	
	
	
//function to normalize busines name with hyphen	
	
function normalizeBusinessName(name) {
  // Split into words, trim spaces, filter out empties
  const words = name.trim().split(/\s+/).filter(Boolean);
  
  // If only one word, return as is, else join with '-'
  return words.length > 1 ? words.join("-") : words[0];
}	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
//function to convert the json generate by openAI to wordpress Gutenbeerg syntax

// Utility: Convert AI JSON → WP Gutenberg blocks
function convertJsonToWpBlocks(pageJson) {
  let content = "";

  pageJson.sections.forEach((section) => {
	 // alert(section.images[0].url)
    content += `<!-- wp:group {"className":"custom-section"} -->
      <div class="wp-block-group custom-section">
        <h2>${section.title}</h2>
        <p>${section.paragraph}</p>
			
        
      </div>
    <!-- /wp:group -->`;
	
	if(section.images && section.images.length > 0){
		section.images.forEach((img) =>{
		content +=` <!-- wp:image {"url":"${img.url}","alt":"${img.alt || section.title}"} -->
		<div class="wp-block-image">
		 <img src="${img.url}"  class="section-image"/>
		 </div>
		 <!-- /wp:image -->
		 `;
		});
	}
	
	
	  
	
	
	
  }); 

  return content;
}
	
	
	
	
	
	
	
const viewWebsite=async()=>{
 window.location.href=localStorage.getItem('url_site');

}	
	
	
	
const goToDashboard=async()=>{

 navigate("/dashboard")
}		
	
	
	
	
	
// rest API to create a new website subdomain on the server hosting


const createNewWebsite=async()=>{
	var formattedBusinessName=normalizeBusinessName(businessName)
	
	 try {
    // Format the path from business name
    const path = businessName.toLowerCase().replace(/\s+/g, '-');

    // Send POST request to your WordPress REST API
  //  const response = await axios.post('http://localhost/zuribuild/wp-json/custom/v1/create-site/', {
	 
	  
	// const response = await axios.post('http://localhost/zuribuild/wp-json/custom/v1/create-site/', {
		 const response = await axios.post('http://localhost/zuribuild/wp-json/custom/v1/create-site/', {
      path: 'zuribuild/'+formattedBusinessName,
      title: businessName,
	  domain: 'localhost/',
	  template: 'bravada'
    },
	{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        },
      }
	  );

    // Log the new site data
    console.log('New site created:', response.data);
	setUrlPath('zuribuild/'+formattedBusinessName);
	//alert(response.data.site_id);
	saveWebsiteClientInformationToDatabase(businessName,'zuribuild/'+formattedBusinessName)
 //  saveWebsiteClientInformationToDatabase(businessName,urlPath)
    // Example: access the new site
    console.log('Visit the site at:', response.data.url);
	//alert(response.data.url);
   
    return response.data.url;
  } catch (error) {
	  alert(error.message)
    console.error('Error creating website:', error.response?.data || error.message);
  }
}



const loginUser=async()=>{
	//alert(firebaseUser)
	
		const payload={
		user_id: 3,
        
		
	  }
	
	await	  axios.post("http://10.0.0.73/zuribuildAPI/login-user.php", payload, {
	 // await	  axios.post("http://localhost/zuribuildAPI/add-user.php", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
	
	console.log(res.data)
 // alert("Congratulation !!! Your registration was successful");
    
	

 // navigate('/dashboard');
  
	
	 
    })
     
     .catch ((err)=> {
		 setShowSpinner("none")
		console.log(err)
      console.error(err.message);
	  
	   toast.error(err.message, {
      position: 'top-right',
    });
	
		
	
    })
	
	
	
	
}






const saveWebsiteClientInformationToDatabase=async(website_name,wp_url)=>{
	 setShowSpinner('inline-block')
	  const payload={
		 website_name:website_name, 
		 wp_url: wp_url,
		 id:1,
		 created_at: new Date(),
		 expiry_date: new Date(),
	  }
	  axios.post("http://localhost/zuribuildAPI/add-website.php", payload, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then((res) => {
		 setShowSpinner('none');
      console.log("Response:", res.data);
	
  alert("Websites added successfully");
  
 // getNewImagesForWebsite();
 createWebsiteStructureViaAI(wp_url);
 deleteSamplePage(wp_url);	
	 
    })
    .catch((err) => {
		 setShowSpinner('none')
      console.error("Error:", err);
	alert(err)
    });
}





// rest api to delete the sample page that is automatically create when we create a new website

const deleteSamplePage=async(wp_url)=>{
	axios.delete("http://localhost/zuribuild/"+wp_url+"/wp-json/wp/v2/pages/2", {
 headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        }
})
.then(
res => {
	alert("Default page deleted")
})
.catch(err => {
	alert(err)
	console.log(err)
});
	
}


// rest API to generate images that will be use for the website via pexels API

const getNewImagesForWebsite=async()=>{

axios.get('https://api.pexels.com/v1/search', {
    headers: {
      Authorization: 'hlMsBY7tC1kHzAmGK2M4SwixocehvaIwi5oV0joaWe0HhQA5tS3UDzPq',
    },
    params: {
      query: businessType,
      per_page: 15,
    },
  })
  .then((response) => {
    // ✅ Success
    console.log("Photos fetched successfully!");
    const photos = response.data.photos;
	setRemoteImages(response.data.photos);
	console.log(photos)
   /* photos.forEach((photo, i) => {
      console.log(`${i + 1}. ${photo.src.medium}`);
    }); */
  })
  .catch((error) => {
    // ❌ Error
    if (error.response) {
      console.error("API responded with error:", error.response.status, error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error setting up request:", error.message);
    }
  });
}	
	
	
	
// rest API to save media library to the website to wordpress API
const saveImagesLibray=async()=>{


alert("save images libraries for the current website")
}
















// rest API TO CREATE AND STRUCTURE CONTENT with openAI API
const createWebsiteStructureViaAI=async(wp_url)=>{
//alert("the website json content had been create through openAI")
const OPENAI_API_KEY='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';
try {
    const response = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-5", // lightweight but strong
        messages: [
          {
            role: "system",
            content: "You are an AI that generates structured JSON for professional websites."
          },
          {
            role: "user",
            content: `
Generate a structured JSON for a professional website. 
It must have 4 pages: Home, About, Services, Contact. 
Each page should contain sections with title, paragraph, and images.
If services are provided, make sure to create a detailed Services page.
include navigation menu that will match the number of pages and each menu will 
have the name or title of the pages created.
if images are not provided use a default placeholder images instead from the link
https://placehold.co/widthxheight .

Business Info:
- Name: ${businessName}
- Description: ${businessType}
- Address: ${businessAddress || "Not provided"}
- Email: ${businessEmail || "Not provided"}
- Phone: ${businessPhone || "Not provided"}
- Services: ${JSON.stringify(services || [])}

Use these image URLs where relevant if available:
${images.join("\n")}
          `
          }
        ],
        
      },
      {
        headers: {  
          Authorization: `Bearer ${OPENAI_API_KEY}`,
          "Content-Type": "application/json"
        }
      }
    );

    const aiContent = response.data.choices[0].message.content;
	//alert(response.data.choices[0].message.content)
	//alert(urlPath);
	console.log(aiContent);
	//setOpenAIResult(JSON.parse(aiContent))
	var segmentizedAIContent=JSON.parse(aiContent)
	 createPagesForWebsite(wp_url,segmentizedAIContent);
/*	setTimeout(function() {
  createPagesForWebsite(wp_url,segmentizedAIContent);
}, 10000); */
	
	
  //  return JSON.parse(aiContent); // structured JSON ready to send to WordPress API
  } catch (error) {
    console.error("Error generating site content:", error);
	//createWebsiteStructureViaAI();
    return null;
  }	
	
}







//function to generate pages for the website we just created 


const createPagesForWebsite=async(wp_url,content)=>{
//	alert(wp_url)
	var createdPageNumber=0;
	var pagesCreated=[];
	
	
	for (let page of content.pages) {
      const content = convertJsonToWpBlocks(page);
  // alert(page.id);
   
     try{
   const response=  await axios.post(
      //  "http://localhost/"+wp_url+"/wp-json/wp/v2/pages",
	   "http://localhost/"+wp_url+"/wp-json/wp/v2/pages",
        {
          title: page.id,
		 // title: "page"+createdPageNumber+1,
		//  slug: "page"+createdPageNumber+1,
          content: content,
          status: "publish"
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
	  console.log('Page created successfully:', response.data);
	   const pageId = response.data.id;
      const pageTitle = response.data.title.rendered;
      createdPageNumber+=1;
	  
	  
	//  pagesCreated.push([pageTitle,pageId])
   //   console.log(`✅ Page created: ${pageTitle} (ID: ${pageId})`);
	
	 }
	 
	 catch (error) {
		 alert(error)
            console.error('Error creating page:', error.response ? error.response.data : error.message);
            throw error;
			//createPagesForWebsite();
        }
	  
    }



	
}






//function to resend verificstion link----------------------------------------------------------------------------------------------------------------------
  const handleResend = async () => {
	  
	  const actionCodeSettings={
		url: "https//hermanntrucking.ca/login",
        handleCodeInApp: true		
		  
	  }
	  
	  
    if (auth.currentUser) {
      try {
        await sendEmailVerification(auth.currentUser);
        alert("Verification email resent! Check your inbox.");
      } catch (error) {
        alert(error.message);
      }
    } else {
      alert("No user is logged in.");
    }
  };
  
  
  
  
  
  
  
  
  
  
  
  







// rest API to create pages for the website though the wordpress
const goToWizard=async()=>{
	
	navigate("/ai-wizard")
}




	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
//function to edit the website-----------------------------------------------------------------------------------
const editWebsite=async(wp_url,website_content)=>{

// alert(wp_url);
 navigate("/edit-website",{
	state: { website_content: website_content}
 });
}	
	
	
	
	
	
	
	
	
	
	
	
	
	
	{/*if (paymentData.loading) return <p>Calculating local price...</p>;	*/}
	
	
	
	
	
	
	
	
	
  return (
  <>
  
  <style>{`

        body {

          margin: 0;

          font-family: Arial, sans-serif;

          background-color: #fff;

          color: #000;

        }



       



        .logo {

          font-weight: bold;

          font-size: 20px;

          color: red;

        }



        .step {

          font-size: 14px;
          font-weight:550;
          color: #555;
         
		  
        }



        /* Progress Bar */

        .progress-bar {

          width: 100vw;

          height: 4px;

          background-color: rgb(228,228,230);

        }
		
		
		
		#progress-indicator {

         // width: 20vw;

          height: 4px;

          background-color: black;
		  transition: width 0.6s ease; 

        }



        /* Body */

        .container {

          display: flex;

          justify-content: center;

          align-items: center;
          width:100%;
          padding: 40px 20px;
         
        }



        .content {

          width: 100%;

          
        //  background:green;
          

        }



        h2 {

          margin-bottom: 20px;

          font-size: 24px;

          color: #000;

        }



        .input-box {

          width: 100%;

          height: 50px;

          border-radius: 25px;

          border: 1px solid #ccc;

          padding: 0 15px;

          font-size: 16px;

          margin-bottom: 20px;

          box-sizing: border-box;

        }



        .btn {

          width: 100%;

          height: 50px;

          border-radius: 25px;

          border: none;

          background-color: purple;

          color: white;

          font-size: 16px;

          cursor: pointer;

          transition: 0.3s;

        }

  .website-block{
  width: 25vw;
	display: flex;
		flex-wrap: wrap;
	height: 200px;
	border-radius: 10px;
	box-shadow: 5px 5px 5px silver;
	
   margin: 15px;
   overflow:hidden;
  }
  
  
  
  

/* Fade effect */
        .fade {
		padding-bottom:70px;
		margin-top:70px;
          opacity: 0;
          transform: translateY(10px);
          animation: fadeIn 0.6s ease forwards;
        }

        @keyframes fadeIn {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }



        .btn:hover {

          background-color: #5a0e8f;

        }
   
   .website-btn{

   width:65%;
   margin-left:5px;
   font-size:12px;
  
   }
   
   .btn-delete{
   background-color:black;
   }
   
    .website-block-action{
	
	 background: linear-gradient(to bottom, rgba(128,0,128,0.8), rgba(0,0,0,0.8));
	 position:absolute;
	border-radius:10px;
	 z-index:1000;
	width:25vw;
	height:200px;
	}
	
	.title-website{
	text-align:center;
	color:white;
	font-weight:bold;
	margin-top:20px;
	}


        /* Responsive */

     .card{
	border:3px solid purple	;
padding:10px;
box-shadow: 0px 0px 10px silver;	
		 
	 }



        @media (max-width: 767px) {

          .content {

            width: 100% !important;
			

          }
		  
		  		    .website-block{
  width: 90vw !important;
	margin: 5px !important;
  }
  
  .website-block-action{
  width: 90vw !important;
  }
  
  .your-website-title{
  margin-left: 20px !important;
  text-align:justify !important;
  }
  
 .block-website-card{
	 width:100vw !important;
	 align-items: center !important;
	 justify-content: center;
 }
 
 .card{
	width:80vw !important; 
	
 }
        }

      `}</style>



      {/* Header */}

     


    <Header/>




      {/* Body */}

      <div className="container">
	  
	    {step === 0 && (
		 <div className="card" style={{
		//borderColor:'black',
		marginTop:'100px',
		width:'35vw',
	}}>
	
	<h2
	style={{
		color:'black',
       
		textAlign:'justify',
	  fontSize: '26px',
	  fontWeight: '800',
	  letterSpacing: '-1px',
	  textDecoration: 'none', 
	}}
	
	>{t("credit.top_up_credit")}</h2>
	<p>{t("credit.how_to_pay")}</p>
          <button className="btn" onClick={goToPayment}>
			
			{t("credit.purchase_here")}
			<div class="spinner-grow spinner-grow-sm" role="status" 
			style={{
				marginLeft:'10px',
				display:showSpinner,
			}}>
 
</div>
			</button>
			
			
			
			
			
			   <button className="btn" onClick={goToGiftCode}  style={{
				   backgroundColor:'green',
				   marginTop:'10px',
				   }}>
			
			{t("credit.use_gift")}
			<div class="spinner-grow spinner-grow-sm" role="status" 
			style={{
				marginLeft:'10px',
				
				display:showSpinner,
			}}>
 
</div>
			</button>
		 </div> 
	  )} 
	  
	  
	  
	    {step === 1 && (
         <div className="card" style={{
		//borderColor:'white',
		marginTop:'100px',
		width:'35vw',
	}}>
	
	 <h2
	 style={{
		color:'black',
       
		textAlign:'justify',
	  fontSize: '26px',
	  fontWeight: '800',
	  letterSpacing: '-1px',
	  textDecoration: 'none', 
	 }}
	 
	 >
	 {t("credit.top_up_credit")}
	 </h2>
	<p>{t("credit.gift_code")} </p>
	 
      <input type="text" className="input-box"

      style={{
        textTransform: 'uppercase'
	  }}		  
		  placeholder={t("credit.enter_gift_code")} 
		
		  value={giftCode}
 onChange={(e) => 
   setGiftCode(e.target.value)
 }		
		  />
		  
		
		
		
		 <button className="btn"  
		 onClick={verifyGiftCode} 
	   style={{
		  // backgroundColor:'silver',
		   marginTop:'10px'
	   }}
	   >
			{t("credit.send")}
			
			<div class="spinner-grow spinner-grow-sm" role="status" 
			style={{
				marginLeft:'10px',
				display:showSpinner,
				
			}}>
 
</div>
			</button>		
		
		

       <button className="btn" onClick={goToMain} 
	   style={{
		   backgroundColor:'silver',
		   marginTop:'10px',
		   color:'black',
	   }}>
			{t("credit.go_back")}
			
			<div class="" role="status" 
			style={{
				marginLeft:'10px',
				//display:showSpinner,
				
			}}>
 
</div>
			</button>		
		  
    </div>
		  
	  )} 
	  
	  
	  
	  
	  
	    {step === 2 && (
        <div className="card" style={{
		//borderColor:'white',
		marginTop:'100px',
		width:'35vw',
	}}>
      <h2   style={{
		  color:'black',
       
		textAlign:'justify',
	  fontSize: '26px',
	  fontWeight: '800',
	  letterSpacing: '-1px',
	  textDecoration: 'none', 
		  
	  }}>
	  {t("credit.top_up_credit")}
	  </h2>
      <p>Local Price: <strong>{paymentData.currency} {paymentData.price}</strong></p>
     
      <button 
      className="btn"
	  onClick={() => {
        handleFlutterPayment({
         callback: async (response) => {
          // 1. Immediately close modal
          closePaymentModal();
           
		 //  alert(response.status)
          // 2. Ask your PHP backend if the Webhook has finished processing
          if (response.status === "successful") {
			//  alert(response.tx_ref)
			
					

            try {
				
			
            //  const  check = await axios.post('http://localhost/zuribuildAPI/check-status.php', {
				 const  check = await axios.post( process.env.REACT_APP_PHP_API_URL+'zuribuildAPI/check-status.php', {
                tx_ref: response.tx_ref
              });
			
			 // alert(check.data.credited);
			  console.log(check.data.credited)
			  
	   navigate("/success-credit");
			  
              if (check.data.credited){ 
			//  alert("Congratulation!!! Credits added you can now generated websites!");
		// navigate("/success-credit")
			//  loginUser();
			  }
			  
			 
            } catch (e) {
              console.log("Still processing...");
            }
			
			
			
          }
          },
        });
      }}>
        
		
		{t("credit.buy_credits_now")}
      </button>
	  
	  
	  
	      <button className="btn" onClick={goToMain} 
		  style={{
			   backgroundColor:'silver',
		   marginTop:'10px',
		   color:'black',
		  }}>
			
			{t("credit.go_back")}
			<div class="" role="status" 
			style={{
				
				
				
			}}>
 
</div>
			</button>
    </div>
		  
	  )} 
 
   


      </div> 
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
 
	  
	  
	<ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"

/>  
	  
	  
	  
	  
	  
	  
	  
	
	  
	  
	  </>
  );
}